export const linkVariables = [
	'%contract_link%',
	'%invoice_link%',
	'%quote_link%',
	'%questionnaire_link%',
	'%galleries_link%'
];

export const noReloadControllers = {
	CalendarController: true,
	JobsOverviewController: true,
	LeadsOverviewController: true,
	ClientsController: true,
	PaymentsOverviewController: true
}

export function hasSomeParentTheClass(element, classname) {
	if (element.className.split(' ').indexOf(classname) >= 0) return true;
	return (
		element.parentElement &&
		hasSomeParentTheClass(element.parentElement, classname)
	);
}

export function isInViewport(element) {
	const rect = element.getBoundingClientRect();
	return (
		rect.top >= 0 &&
		rect.left >= 0 &&
		rect.bottom <=
			(window.innerHeight || document.documentElement.clientHeight) &&
		rect.right <= (window.innerWidth || document.documentElement.clientWidth)
	);
}



// WEBPACK FOOTER //
// ./web/js/helper/utils.js